import {
  Breakpoints,
  BreakpointWrapper,
  Container as VWContainer,
  ContainerGutter,
  ContainerWrap,
  CTA,
  List,
  ListItem,
  styled,
  Text,
  TextAppearance,
  TextColor,
} from '@volkswagen-onehub/components-core';
import { Close } from '@volkswagen-onehub/icons-core';
import {
  CloseHandleV2,
  FocusLayerSizeV2,
  LayerManagerV2,
  ShimBackgroundTypeV2,
} from '@volkswagen-onehub/layer-manager';
import React from 'react';
import { useStore } from 'react-redux';
import { LayerManagerWrapper, useFeatureAppEnvironment, useFeatureServices } from 'src/feature-app';
import { LatinoBlackTitle, LatinoTitleBold } from '..';

const Div = styled.div`
  width: 100%;
  height: var(--100vh);
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: cover;
`;

const Container = styled.div<{ background: string }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  /* background-color: #000000; */
  /* background-image: ${(props) => `url(${props.background})`}; */
  width: 100%;
  height: 100%;
  color: #ffffff;
  background-size: cover;
  background-position: 20%;
  @media all and (min-width: 960px) {
    background-position: unset;
  }
`;

const CloseDiv = styled.div`
  position: absolute;
  right: 20px;
  top: 20px;
`;
interface Copy {
  number: string;
  title: string | JSX.Element;
  text: string | JSX.Element;
  background?: string;
  backgroundMob?: string;
}

const copies: Copy[] = [
  {
    number: '01.',
    title: (
      <>
        Escápate para sentir <br />
        la adrenalina...
      </>
    ),
    text: 'Elige el camino más impredecible, al volante de un deportivo con mucho carácter.',
    background: 'https://cdn.volkswagen.es/repository/app/vw-oneform/assets/images/taigo/vw-taigo-1.png',
    backgroundMob: 'https://cdn.volkswagen.es/repository/app/vw-oneform/assets/images/taigo/vw-taigo-1-mob.png',
  },
  {
    number: '02.',
    title: (
      <>
        …o para disfrutar del <br />
        estilo más cosmopolita.
      </>
    ),
    text: 'Descubre los secretos de la ciudad con el máximo confort y lo último en tecnología.',
    background: 'https://cdn.volkswagen.es/repository/app/vw-oneform/assets/images/taigo/vw-taigo-2.png',
    backgroundMob: 'https://cdn.volkswagen.es/repository/app/vw-oneform/assets/images/taigo/vw-taigo-2-mob.png',
  },
  {
    number: '03.',
    title: 'Pero para vivirlo todo...',
    text: (
      <>
        Necesitas tenerlo todo. Y nosotros tenemos el plan e incluso la excusa para poder vivirlo.
        <br />
        <Text bold>¿En modo deportivo? </Text>Para disfrutar de la naturaleza. <Text bold>¿O urbanita? </Text>Y
        desconectar en un oasis dentro de la ciudad.
        <br />
        Tú eliges.
      </>
    ),
    background: 'https://cdn.volkswagen.es/repository/app/vw-oneform/assets/images/taigo/vw-taigo-3.png',
    backgroundMob: 'https://cdn.volkswagen.es/repository/app/vw-oneform/assets/images/taigo/vw-taigo-3-mob.png',
  },
];

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  gap: 12px;
`;

const LineHeight = styled.span`
  h1 {
    line-height: 1;
  }
`;

const TextWrapper = styled.div`
  padding-top: 12px;
  @media all and (min-width: 560px) {
    padding-top: 16px;
    width: 50%;
  }
  @media all and (min-width: 1600px) {
    padding-top: 20px;
  }
  & button span {
    color: #ffffff;
  }
`;

const Position = styled.div`
  position: absolute;
  top: 15%;
  padding: 0 var(--size-grid001);
  @media all and (min-width: 560px) {
    padding: 0 var(--size-grid002);
  }
`;

const BackgroundImage = styled.div<{ number: number }>`
  background-image: ${(props) =>
    props.number === 1
      ? `url(${copies[0].backgroundMob})`
      : props.number === 2
      ? `url(${copies[1].backgroundMob})`
      : `url(${copies[2].backgroundMob})`};
  width: 100%;
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  transition: background-image 0.5s ease-in 0s;
  z-index: 4;
  position: absolute;
  top: 0px;

  @media all and (min-width: 960px) {
    background-image: ${(props) =>
      props.number === 1
        ? `url(${copies[0].background})`
        : props.number === 2
        ? `url(${copies[1].background})`
        : `url(${copies[2].background})`};
  }
`;
const ListWrapper = styled.div`
  ul {
    gap: 0;
  }
`;

export const Slide = ({ copy, fullPageApi }: { copy: Copy; fullPageApi: any }) => {
  const layerManager = useFeatureServices()['layer-manager'] as LayerManagerV2;
  const store = useStore();
  const env = useFeatureAppEnvironment();

  const handleKoLayer = () => {
    const layer = layerManager.openFocusLayer(
      renderLayer,
      {},
      {
        size: FocusLayerSizeV2.B,
        userCloseable: true,
        shimBackgroundType: ShimBackgroundTypeV2.OPAQUE,
        disableReturnFocus: true,
        onClose: () => {
          fullPageApi.setAllowScrolling(true);
        },
      }
    );
  };

  const renderLayer = (state: any, close: CloseHandleV2<any, any>) => {
    return (
      <LayerManagerWrapper store={store} env={env}>
        <div id="scrollElement" style={{ padding: 'var(--size-grid001)' }}>
          <VWContainer gutter={ContainerGutter.static200} wrap={ContainerWrap.always}>
            <Text bold appearance={TextAppearance.headline0200}>
              {' '}
              ¿Cómo funciona el sorteo?
            </Text>
            <Text appearance={TextAppearance.copy150}>
              {' '}
              Para participar solo tienes que seleccionar tu excusa para vivir esa experiencia: ¿modo deportivo o
              urbanita?{' '}
            </Text>
            <Text bold appearance={TextAppearance.copy150}>
              En esta experiencia disfrutarás:{' '}
            </Text>
            <Text appearance={TextAppearance.copy150}>
              <i>Si eliges el modo deportivo…</i>
              <ListWrapper>
                <List>
                  <ListItem>
                    Visita a la fábrica de Volkswagen en Navarra para ver cómo se fabrica el Nuevo Taigo.
                  </ListItem>
                  <ListItem>
                    Estancia de dos días en el Alma Hotels de Pamplona en la habitación Gran Deluxe para dos personas,
                    con desayuno incluido.
                  </ListItem>
                  <ListItem>
                    Un plan aventurero que incluye una ruta ciclista guiada por los mejores parajes naturales.
                  </ListItem>
                  <ListItem>Una cena en el Restaurante Alma para dos personas.</ListItem>
                </List>
              </ListWrapper>
            </Text>
            <Text appearance={TextAppearance.copy150}>
              <i>Si eliges el modo urbanita…</i>
              <ListWrapper>
                <List>
                  <ListItem>
                    Visita a la fábrica de Volkswagen en Navarra para ver cómo se fabrica el Nuevo Taigo.
                  </ListItem>
                  <ListItem>
                    Estancia de dos días en el Alma Hotels de Pamplona en la habitación Gran Deluxe para dos personas,
                    con desayuno incluido.
                  </ListItem>
                  <ListItem>Acceso al spa.</ListItem>
                  <ListItem>Una cena en el Restaurante Alma para dos personas.</ListItem>
                </List>
              </ListWrapper>
            </Text>
          </VWContainer>
          <CloseDiv onClick={() => close({}, {}, {})}>
            <Close />
          </CloseDiv>
        </div>
      </LayerManagerWrapper>
    );
  };

  return (
    <div className="slide">
      <Container background={copy.background}>
        <Position>
          <TitleWrapper>
            <NumberTitle copyNumber={copy.number} />
            <LineHeight>
              <LatinoTitleBold>{copy.title}</LatinoTitleBold>
            </LineHeight>
          </TitleWrapper>
          <TextWrapper>
            <BodyCopy bodyText={copy.text} copyNumber={copy.number} />
            {copy.number === '03.' ? (
              <div style={{ paddingTop: '20px' }}>
                <CTA
                  tag="button"
                  emphasis="tertiary"
                  onClick={() => {
                    handleKoLayer();
                    fullPageApi.setAllowScrolling(false);
                  }}
                >
                  ¿Y cómo participo en el sorteo?
                </CTA>
              </div>
            ) : null}
          </TextWrapper>
        </Position>
      </Container>
    </div>
  );
};

export function ThirdSlide({ number, fullPageApi }: any) {
  return (
    <>
      <div style={{ backgroundColor: '#000000' }}>
        <Div>
          <BackgroundImage number={number} className="background-image">
            {copies.map((copy: Copy) => {
              return <Slide key={copy.number} copy={copy} fullPageApi={fullPageApi} />;
            })}
          </BackgroundImage>
        </Div>
      </div>
    </>
  );
}
interface PropsComponents {
  copyNumber?: string;
  bodyText?: string | JSX.Element;
}
const NumberTitle = (props: PropsComponents) => {
  return (
    <>
      <BreakpointWrapper max={Breakpoints.b960}>
        <LatinoBlackTitle size="24px" letterSpacing="0.05em">
          {props.copyNumber}
        </LatinoBlackTitle>
      </BreakpointWrapper>
      <BreakpointWrapper min={Breakpoints.b960} max={Breakpoints.b1280}>
        <LatinoBlackTitle size="var(--textappearances-headline350-fontsize)" letterSpacing="0.05em">
          {props.copyNumber}
        </LatinoBlackTitle>
      </BreakpointWrapper>
      <BreakpointWrapper min={Breakpoints.b1280} max={Breakpoints.b1920}>
        <LatinoBlackTitle size="var(--textappearances-headline400-fontsize)" letterSpacing="0.05em">
          {props.copyNumber}
        </LatinoBlackTitle>
      </BreakpointWrapper>
      <BreakpointWrapper min={Breakpoints.b1920}>
        <LatinoBlackTitle size="var(--textappearances-headline450-fontsize)" letterSpacing="0.05em">
          {props.copyNumber}
        </LatinoBlackTitle>
      </BreakpointWrapper>
    </>
  );
};

const BodyCopy = (props: PropsComponents) => {
  return (
    <>
      {props.copyNumber === '03.' ? (
        <>
          <BreakpointWrapper max={Breakpoints.b1280}>
            <Text appearance={TextAppearance.headline0200} color={TextColor.inherit}>
              {props.bodyText}
            </Text>
          </BreakpointWrapper>
          <BreakpointWrapper min={Breakpoints.b1280} max={Breakpoints.b1920}>
            <Text appearance={TextAppearance.headline0250} color={TextColor.inherit}>
              {props.bodyText}
            </Text>
          </BreakpointWrapper>
          <BreakpointWrapper min={Breakpoints.b1920}>
            <Text appearance={TextAppearance.headline0300} color={TextColor.inherit}>
              {props.bodyText}
            </Text>
          </BreakpointWrapper>
        </>
      ) : (
        <>
          <BreakpointWrapper max={Breakpoints.b1280}>
            <Text appearance={TextAppearance.headline0250} color={TextColor.inherit}>
              {props.bodyText}
            </Text>
          </BreakpointWrapper>
          <BreakpointWrapper min={Breakpoints.b1280} max={Breakpoints.b1920}>
            <Text appearance={TextAppearance.headline0300} color={TextColor.inherit}>
              {props.bodyText}
            </Text>
          </BreakpointWrapper>
          <BreakpointWrapper min={Breakpoints.b1920}>
            <Text appearance={TextAppearance.headline0350} color={TextColor.inherit}>
              {props.bodyText}
            </Text>
          </BreakpointWrapper>
        </>
      )}
    </>
  );
};
